module.exports = __webpack_public_path__ + "img/home-two-4.dcd5a999.png";